import RfAndroidFireTvIcon from "@/components/icons/RfAndroidFireTvIcon.vue";
import RfAndroidPhoneTabletIcon from "@/components/icons/RfAndroidPhoneTabletIcon.vue";
import RfAppleTvIcon from "@/components/icons/RfAppleTvIcon.vue";
import RfIphoneIpadIcon from "@/components/icons/RfIphoneIpadIcon.vue";
import RfLanguageIcon from "@/components/icons/RfLanguageIcon.vue";
import RfRokuIcon from "@/components/icons/RfRokuIcon.vue";
import RfTuneIcon from "@/components/icons/RfTuneIcon.vue";

export const PushDevice = { value: "push_device", text: "Push Device" };

export const DefaultDeviceOptions = {
  web: {
    icon: RfLanguageIcon,
    value: "web",
    text: "Web",
    fullTitle: "Desktop & Mobile Web",
    description:
      "Works on Desktop and mobile browsers. Supports Safari, Chrome, Firefox, Edge, and Internet Explorer.",
  },
  ios: {
    icon: RfIphoneIpadIcon,
    value: "ios",
    text: "iPhone/iPad",
    fullTitle: "iPhone & iPad",
    description:
      "Works on Apple iOS iPhone and iPad native apps. Requires the addition of the Recurly Engage iOS SDK to your app.",
  },
  tv_os: {
    icon: RfAppleTvIcon,
    value: "tv_os",
    text: "Apple TV",
    fullTitle: "Apple TV",
    description:
      "Works on Apple TV second generation or later running tvOS. Requires the addition of Recurly Engage tvOS SDK to your app.",
  },
  android_os: {
    icon: RfAndroidPhoneTabletIcon,
    value: "android_os",
    text: "Android",
    fullTitle: "Android Phone & Tablet",
    description:
      "Works on Android phone, tablet. Requires the addition of the Recurly Engage Android SDK to your app.",
  },
  android_tv: {
    icon: RfAndroidFireTvIcon,
    value: "android_tv",
    text: "Android TV",
    fullTitle: "Android TV & Fire TV",
    description:
      "Works on Android TV devices and Fire TV. Requires the addition of the Recurly Engage Android SDK to your app.",
  },
  roku_os: {
    icon: RfRokuIcon,
    value: "roku_os",
    text: "Roku",
    fullTitle: "Roku",
    description:
      "Works on Roku devices including Roku TV. Requires the addition of Recurly Engage Roku SDK to your app.",
  },
};

export const DeviceTypeWording = {
  ...DefaultDeviceOptions,
  custom_defined: {
    icon: RfTuneIcon,
    value: "custom_defined",
    text: "Custom",
    fullTitle: "Custom Device",
  },
};

export const customSegmentTypeDevice = {
  name: "Custom",
  child: "customDevices",
  value: "custom_defined",
};

export const SegmentTypeDevices = {
  os_family: { name: "OS", child: "deviceOs", value: "os_family" },
  browser_family: { name: "Browsers", child: "browsers", value: "browser_family" },
  device_family: { name: "Manufacturer", child: "deviceType", value: "device_family" },
  device_target: { name: "SDK", child: "devices", value: "device_target" },
};

export const getSegmentTypeDevices = customDevicesEnabled => ({
  ...SegmentTypeDevices,
  ...(customDevicesEnabled && { [customSegmentTypeDevice.value]: customSegmentTypeDevice }),
});

export const DeviceTypes = {
  iPhone: { name: "Apple iPhone", value: "iPhone" },
  iPad: { name: "Apple iPad", value: "iPad" },
  Mac: { name: "Apple Mac", value: "Mac" },
  Amazon: { name: "Amazon", value: "AFT" },
  Nexus: { name: "Nexus", value: "Nexus" },
  Pixel: { name: "Pixel", value: "Pixel" },
  Samsung: { name: "Samsung", value: "Samsung" },
  Moto: { name: "Motorola", value: "Moto" },
  GenericSmartphone: { name: "Generic Smartphone", value: "Generic Smartphone" },
  LG: { name: "LG", value: "LG" },
  Huawei: { name: "Huawei", value: "Huawei" },
  Lumia: { name: "Lumia", value: "Lumia" },
  Vivo: { name: "Vivo", value: "vivo" },
  Oppo: { name: "Oppo", value: "Oppo" },
  OnePlus: { name: "OnePlus", value: "OnePlus" },
  Poco: { name: "Poco", value: "POCO" },
  Kindle: { name: "Kindle", value: "Kindle" },
  Other: { name: "Other", value: "Other" },
};

export const DeviceOSes = {
  Android: { name: "Android", value: "Android" },
  iOS: { name: "iOS", value: "iOS" },
  Windows: { name: "Windows", value: "Windows" },
  Mac: { name: "MacOS", value: "Mac OS X" },
  Linux: { name: "Linux", value: "Linux" },
  Roku: { name: "Roku", value: "Roku" },
  Tizen: { name: "Tizen", value: "Tizen" },
  WebOS: { name: "WebOS", value: "Web0S" },
  Chrome: { name: "Chrome", value: "Chrome OS" },
  Other: { name: "Other", value: "Other" },
};

export const Browsers = {
  "Chrome": { name: "Chrome", value: "Chrome" },
  "Chrome Mobile": { name: "Chrome Mobile", value: "Chrome Mobile" },
  "Safari": { name: "Safari", value: "Safari" },
  "Mobile Safari": { name: "Mobile Safari", value: "Mobile Safari" },
  "Chrome iOS": { name: "Chrome iOS", value: "Chrome Mobile iOS" },
  "Edge": { name: "Edge", value: "Edge" },
  "Edge Mobile": { name: "Edge Mobile", value: "Edge Mobile" },
  "Firefox": { name: "Firefox", value: "Firefox" },
  "Firefox Mobile": { name: "Firefox Mobile", value: "Firefox Mobile" },
  "Firefox iOS": { name: "Firefox iOS", value: "Firefox iOS" },
  "Opera": { name: "Opera", value: "Opera" },
  "Google": { name: "Google", value: "Google" },
  "Opera Mobile": { name: "Opera Mobile", value: "Opera Mobile" },
  "Samsung Internet": { name: "Samsung Browser", value: "Samsung Internet" },
  "Amazon Silk": { name: "Amazon Silk", value: "Amazon Silk" },
};

export const Devices = [
  { name: "Android Phone", value: { device_type: "android_os", device_category: "phone" } },
  {
    name: "Android and Fire Tablet",
    value: { device_type: "android_os", device_category: "tablet" },
  },
  { name: "Android and Fire TV", value: { device_type: "android_tv", device_category: "tv" } },
  {
    name: "Android TV (Exclude Fire)",
    value: { device_type: "android_tv", device_category: "tv", device_model: "^(?!AFT).*" },
  },
  {
    name: "Android Tablet (Exclude Fire)",
    value: { device_type: "android_os", device_category: "tablet", device_model: "^(?!KF).*" },
  },
  { name: "Desktop & Mobile Web", value: { device_type: "web" } },
  {
    name: "Fire Tablet",
    value: { device_type: "android_os", device_manufacturer: "Amazon", device_model: "^KF" },
  },
  {
    name: "Fire TV",
    value: { device_type: "android_tv", device_manufacturer: "Amazon", device_model: "^AFT" },
  },
  {
    name: "Google TV",
    value: { device_type: "android_tv", device_category: "tv", device_model: "Google TV" },
  },
  {
    name: "Sony TV",
    value: { device_type: "android_tv", device_category: "tv", device_model: "^BRAVIA" },
  },
  {
    name: "Chromecast",
    value: { device_type: "android_tv", device_category: "tv", device_model: "^Chromecast" },
  },
  { name: "Apple iPhone", value: { device_type: "ios", device_model: "^iPhone" } },
  { name: "Apple iPad", value: { device_type: "ios", device_model: "^iPad" } },
  { name: "Apple TV", value: { device_type: "tv_os" } },
  {
    name: "Roku (1080p)",
    value: { device_type: "roku_os", device_model: "^(3800|3900|3910|3930|3931|8000|D000|H000)" },
  },
  {
    name: "Roku (All)",
    value: {
      device_type: "roku_os",
      device_model: "^(38|39|44|46|48|60|70|80|91|A0|C0|D0|G0|H0|E0)",
    },
  },
];
